var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import Cta from '../shared/Cta.vue';
let ArticleInfo = class ArticleInfo extends Vue {
};
__decorate([
    Prop()
], ArticleInfo.prototype, "classes", void 0);
__decorate([
    Prop()
], ArticleInfo.prototype, "sectors", void 0);
__decorate([
    Prop()
], ArticleInfo.prototype, "article", void 0);
__decorate([
    Prop()
], ArticleInfo.prototype, "titleSize", void 0);
__decorate([
    Prop()
], ArticleInfo.prototype, "currentPage", void 0);
__decorate([
    Prop()
], ArticleInfo.prototype, "activeSectorId", void 0);
ArticleInfo = __decorate([
    Component({
        components: {
            Cta
        }
    })
], ArticleInfo);
export default ArticleInfo;
